import React, { useEffect, useState } from 'react'
import { Link, useLocation } from "react-router-dom";
import "./index.scss";
import { CloseIcon } from "../../../images/icon";
import {parseJSON} from "../../MFEs/Monetization-Sdk/src/helper.js"
import {fetchUserObject} from "../../MFEs/Monetization-Sdk/src/fetchStore.js"
import pubsub from '@viewlift/pubsub';
import Spinner from "../../components/HomeLoadingScreen/Spinner";
import {ANALYTICS} from "../../helpers/analyticsMap.js"

const PersonalizationBanner = (prop) => {
  if (typeof window === "undefined") return  
  const isPersonlizationEnabled = (window?.app_data?.appcmsMain?.personalization?.enablePersonalization && window?.app_data?.appcmsMain?.personalization?.enablePersonalizationBanner);
  if(!isPersonlizationEnabled) return
  const isHomePage = (window?.location?.pathname === "/")
  if(!isHomePage) return

  const location = useLocation()
  const [showPersonalizationBanner, setShowPersonalizationBanner] = useState<boolean>(true);
  const [user, setUser] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const genericMessage = window?.app_data?.appcmsMain?.genericMessages
  const hasPersonalizationContent = (user?.profiles?.[0]?.contentPersonalization?.teams?.length > 0) || 
                                    (user?.profiles?.[0]?.contentPersonalization?.persons?.length > 0) || 
                                    (user?.contentPersonalization?.teams?.length > 0) || 
                                    (user?.contentPersonalization?.persons?.length > 0)
  const bannerText = hasPersonalizationContent ? 
                     (genericMessage?.personalisationBannerText || "This page is based on your interests. You can edit your personalization preferences at any time in your ") : 
                     (genericMessage?.nonPersonalisationBannerText || "You have not selected the favourite team yet, so to choose favourite visit ")
  const bannerHyperlink = hasPersonalizationContent ? 
                         (genericMessage?.personalisationBannerHyperlink || "Account Settings") : 
                         (genericMessage?.nonPersonalisationBannerHyperlink || "Personalization")
  const doesUserClosedPersonalizedBanner = parseJSON(localStorage.getItem("hidePersonalizationBanner"))
     
  useEffect(()=>{
    pubsub.subscribe('isPersonalizationContentUpdated',displayPersonalizationBanner)
    getUser()
    return () => {
      pubsub.unsubscribe('isPersonalizationContentUpdated', displayPersonalizationBanner);
    };
  },[])
  
  useEffect(()=>{
    const pageRefreshStatus = parseJSON(localStorage.getItem("pageRefreshStatus"))
    if (location?.pathname === "/" && pageRefreshStatus) {
      localStorage.setItem("pageRefreshStatus", JSON.stringify(false))
      window.location.reload();
      setIsLoading(true)
    }
  },[])

  useEffect(()=>{
    if(!user) return
    const eventData =  {
      text : (hasPersonalizationContent ? 'personalized': 'non personalized'),
      moduleType: prop?.moduleData?.moduleType || prop?.moduleData?.layout?.type
    }
    pubsub.publish('user-analytics',{ename:ANALYTICS.PERSONALIZATION_POP_UP, data: eventData});
  },[user])

  function displayPersonalizationBanner(bannerVisibilityState){
    localStorage.setItem("hidePersonalizationBanner", JSON.stringify(!bannerVisibilityState))
    setShowPersonalizationBanner(bannerVisibilityState)
  }

  async function getUser() {
    const user = fetchUserObject()
    if(!user) return
    setUser(user)
  }

  function handleLinkClick(){
    const eventData = hasPersonalizationContent
      ? {"edit" : "personalized", moduleType: prop?.moduleData?.moduleType || prop?.moduleData?.layout?.type }
      : {"edit" : "non personalized", moduleType: prop?.moduleData?.moduleType || prop?.moduleData?.layout?.type}
    pubsub.publish('user-analytics',{ename:ANALYTICS.PERSONALIZATION_EDIT_POP_UP, data:eventData});
  }

  if(isLoading) return <Spinner/>
  if(!user) return
  if(!showPersonalizationBanner) return
  if(doesUserClosedPersonalizedBanner) return
  return (
    <div className='personalization-banner-container'>
      <div className='personalization-banner'>
          <div className='banner-text'>
              <div>
                  {bannerText}
                  <Link to={"/user-personalization"} className='hyperlink' onClick={handleLinkClick}>{bannerHyperlink}</Link>
              </div>
          </div>
          <div className='cancel-icon'>
              <CloseIcon onClick={() => displayPersonalizationBanner(false)} />
          </div>
      </div>
    </div>
  )
}

export default PersonalizationBanner